import { render, staticRenderFns } from "./BrokerCompetitions.vue?vue&type=template&id=ad1f524e&scoped=true"
import script from "./BrokerCompetitions.vue?vue&type=script&lang=js"
export * from "./BrokerCompetitions.vue?vue&type=script&lang=js"
import style0 from "./BrokerCompetitions.vue?vue&type=style&index=0&id=ad1f524e&prod&lang=scss"
import style1 from "./BrokerCompetitions.vue?vue&type=style&index=1&id=ad1f524e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1f524e",
  null
  
)

export default component.exports